import { render } from "./edit_form.vue?vue&type=template&id=5e12919b&scoped=true"
import script from "./edit_form.vue?vue&type=script&lang=js"
export * from "./edit_form.vue?vue&type=script&lang=js"

import "./edit_form.vue?vue&type=style&index=0&id=5e12919b&scoped=true&lang=css"
import "./edit_form.vue?vue&type=style&index=1&id=5e12919b&lang=css"

import exportComponent from "E:\\devops.aliyun\\liangting\\liangting_business_web\\seller.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e12919b"]])

export default __exports__